const initialState = {
   settings: {},
   products: [],
   collections: [],
   owner: null,
   selectedProduct: null,
   isLoading: true,
   isSaving: false,
   errors: {},
};

export default initialState;
